/** Storefront domain of a shop from the guest shop API: primary domain, else myshopify domain. */
export const getShopDomain = (shop) => shop?.domain || shop?.myshopify_domain || null;

/** Storefront URL of a shop (https://{domain}), or null. */
const getShopUrl = (shop) => {
    const domain = getShopDomain(shop);
    return domain ? `https://${domain}` : null;
};

export default getShopUrl;
